import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import ContributorAction from '../../../../referencial/components/contributor/actions/ContributorAction'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import { getQualificationSelectOptions, getStatusSelectOptions } from '../../../../utils/StatusUtil'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import { Grid2 } from '@mui/material'
import CampaignAction from '../../../../campaign/actions/CampaignAction'
import { setModal } from '../../../../utils/FormUtils'
import ImportFileModal from './ImportFileModal'
import ReferencialAction from '../../../../referencial/action/ReferencialAction'
import useSandreList from '../../../../utils/customHook/useSandreList'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import MethodAction from '../../../../referencial/components/methods/actions/MethodAction'
import IntegrationModeDialog from '../IntegrationModeDialog'


const setAdvancedFtpModal =(path) => {
    setModal({
        title: i18n.importParam,
        content: <ImportFileModal url={ path } />,
    })
}

const CEMAGREF_Panel = ({
    filters,
    isEditMode,
    onChangeFilters,
}) => {
    const dispatch = useDispatch()
    const {
        contributors,
        qualityCampaigns,
        sandreCodes,
        methods,
    } = useSelector((store) => ({
        contributors: store.ContributorReducer.contributors,
        qualityCampaigns: store.QualityReducer.qualityCampaigns,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        methods: store.MethodReducer.methods,
    }), shallowEqual)

    useEffect(() => {
        dispatch(ContributorAction.fetchContributors())
        dispatch(CampaignAction.fetchQualityCampaigns())
        if (!Object.keys(filters).length) {
            onChangeFilters({
                importMode: 'DATA_ADD_LAST_DATA',
            })
        }
        if (!sandreCodes.length) {
            dispatch(ReferencialAction.fetchSandreCodes())
        }
        if (!methods.length) {
            dispatch(MethodAction.fetchMethods())
        }
    }, [])

    const seasonalities = useSandreList(SANDRE.SEASONALITY)
    const taxonsDev = useSandreList(SANDRE.TAXONS_DEVELOPPEMENT)

    const disabled = !isEditMode
    return (
        <Grid2 container rowSpacing={1}>
            <Grid2 size={12}>
                <fieldset>
                    <legend>&nbsp;{i18n.defaultValue}&nbsp;</legend>
                    <Grid2 container spacing={1} justifyContent='center' alignItems='center'>
                        <Grid2 size={3}><Select label={i18n.status} value={filters.status} onChange={v => onChangeFilters({ status: v })} options={getStatusSelectOptions()} nullLabel='&nbsp;' disabled={disabled} /></Grid2>
                        <Grid2 size={3}><Select label={i18n.qualification} value={filters.qualification} onChange={v => onChangeFilters({ qualification: v })} options={getQualificationSelectOptions()} nullLabel='&nbsp;' disabled={disabled} /></Grid2>
                        <Grid2 size={2}><Select
                            value={filters.campaignId}
                            keyvalue='id'
                            options={qualityCampaigns}
                            label={i18n.campaign}
                            onChange={v => onChangeFilters({ campaignId: v })}
                            disabled={!isEditMode}
                        /></Grid2>
                        <Grid2 size={2}>
                            <Select
                                label={i18n.seasonality}
                                value={filters.seasonality}
                                onChange={v => onChangeFilters({ seasonality: v })}
                                options={seasonalities}
                                nullLabel='&nbsp;'
                                disabled={disabled}
                            />
                        </Grid2>
                        <Grid2 size={2} className='padding-top-1'>
                            <Checkbox label={i18n.accreditation} checked={filters.accreditation} onChange={v => onChangeFilters({ accreditation: v })} disabled={disabled}/>
                        </Grid2>
                        <Grid2 size={4}><MultiContributorsAutocomplete label={i18n.producer} values={filters.producer} onChange={v => onChangeFilters({ producer: v })} options={contributors} disabled={disabled} /></Grid2>
                        <Grid2 size={4}><MultiContributorsAutocomplete label={i18n.determiner} value={filters.determinator} onChange={v => onChangeFilters({ determiner: v })} options={contributors} disabled={disabled} /></Grid2>
                        <Grid2 size={4}><MultiContributorsAutocomplete label={i18n.sampler} values={filters.sampler} onChange={v => onChangeFilters({ sampler: v })} options={contributors} disabled={disabled} /></Grid2>
                        <Grid2 size={4}>
                            <Select
                                label={i18n.protocol}
                                value={filters.protocol}
                                onChange={v => onChangeFilters({ protocol: v })}
                                options={methods}
                                nullLabel='&nbsp;'
                                disabled={disabled}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Select
                                label={i18n.analysisMethod}
                                value={filters.analysisMethod}
                                onChange={v => onChangeFilters({ analysisMethod: v })}
                                options={methods}
                                nullLabel='&nbsp;'
                                disabled={disabled}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Select
                                label={i18n.developmentStatus}
                                value={filters.developpementStatus}
                                onChange={v => onChangeFilters({ developpementStatus: v })}
                                options={taxonsDev}
                                nullLabel='&nbsp;'
                                disabled={disabled}
                            />
                        </Grid2>
                    </Grid2>
                </fieldset>
            </Grid2>
            <Grid2 size={12} container spacing={1} justifyContent='center' alignItems='center'>
                <Grid2 size={2}><Input title={i18n.directory} value={filters.directory} onChange={v => onChangeFilters({ directory: v })} disabled={disabled} /></Grid2>
                <Grid2 size={1}>
                    <a className='btn btn-small secondary-color-back ' onClick={ () => setAdvancedFtpModal(filters.directory)} ><span title={ i18n.importLabelFtp }> <i className='material-icons'>input </i> </span></a>
                </Grid2>
                <Grid2 size={3}><Checkbox label={i18n.renameFic} onChange={v => onChangeFilters({ renameProcessedFiles: v })} disabled={disabled} checked={filters.renameProcessedFiles} /></Grid2>
                <Grid2 size={3}><Checkbox label={i18n.dontProcessFilesInLogs} onChange={v => onChangeFilters({ dontProcessFilesInLogs: v })} disabled={disabled} checked={filters.dontProcessFilesInLogs} /></Grid2>
                <Grid2 size={3}>
                    <Select options={getIntegrationModes()} label={i18n.dataIntegration} value={filters.importMode} labelSpan={<IntegrationModeDialog />}
                        onChange={v => onChangeFilters({ importMode: v })} disabled={disabled}
                    /></Grid2>
            </Grid2>
        </Grid2>
    )
}
CEMAGREF_Panel.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    filters: PropTypes.object,
    isEditMode: PropTypes.bool,
    onChangeFilters: PropTypes.func,
}

export default CEMAGREF_Panel